import { useQuery } from 'react-query';
import { useAPI } from './useAPI';
import { useChuckClientContext } from './useChuckClientContext';
import { CacheKeys } from '../constants';
export const useConversation = (id, initialData) => {
    const { get } = useAPI();
    const { client } = useChuckClientContext();
    return useQuery([CacheKeys.CONVERSATION, id], () => get({ url: `/conversations/${id}` }).then((res) => res.data), Object.assign({ onError: (err) => {
            client.captureException(err);
        } }, (initialData ? { initialData } : {})));
};
//# sourceMappingURL=useConversation.js.map